import { render, staticRenderFns } from "./SettingsPlugins.vue?vue&type=template&id=164233a7&"
import script from "./SettingsPlugins.vue?vue&type=script&lang=ts&"
export * from "./SettingsPlugins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports